export const DIRECTORY_USER = 'DIRECTORY_USER';
export const PARTNER = 'PARTNER';
export const PROVIDER = 'PROVIDER';
export const RESELLER = 'RESELLER';